<template>
    <span
        ref="input"
        class="input"
        :contenteditable="true"
        @blur="onBlur"
    />
</template>

<script>
import { stripHtml } from '@/utils/clipboard';

export default {
    name: 'content-editable',

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    mounted() {
        this.elem = this.$refs.input;
        this.elem.innerText = this.value;
        this.elem.addEventListener('paste', stripHtml);
    },

    destroyed() {
        this.elem.removeEventListener('paste', stripHtml);
    },

    methods: {
        onBlur() {
            this.$emit('input', this.elem.innerText);
        },
    },
};
</script>

<style lang="scss" scoped>
.input {
    display: inline-block;
    padding: 0.375rem 0.5rem;
    min-width: 6em;
    font-size: 0.8125rem;
    text-transform: none;
    // leave the borders split up like this, it's needed for the "invalid" state in flex forms
    // when .is-invalid is added, all of the borders get turned to red
    border: 1px solid transparent;
    border-bottom-color: var(--form-inputBorderColor);
}
</style>
